import { NewspaperIcon } from '@heroicons/react/outline';
import { MissionIcon } from '../../icons/MissionIcon';
import VisionIcon from '../../icons/VisionIcon';
import { LandingAppBar } from '../../components/LandingAppBar';
import Footer from '../../components/Footer';

const supportLinks = [
  {
    name: 'Vision',
    href: '#',
    description:
      'We aspire to be the trusted and preferred talent partner for our clients in the United Arab Emirates\n' +
      'and Gulf Cooperation Council (GCC). We intend to achieve our vision by providing ethical services to our clients\n' +
      'and candidates.\n' +
      'Our intention is very clear: We want to provide great value that surpasses your expectations.\n',
    icon: MissionIcon,
  },
  {
    name: 'Mission',
    href: '#',
    description:
      "We nurture our values to provide industry's flawless expertise.\n" +
      'At V REKRUT, clients and candidates are considered indistinguishable.\n' +
      'Our energy, enthusiasm, and positivity fills the room with passion\n' +
      'and our mission is to enhance this energy, convert it into productivity and deliver quality services to our clients across UAE and GCC.\n',
    icon: VisionIcon,
  },
  {
    name: 'Why to choose us',
    href: '#',
    description:
      'V REKRUT is equipped with specialized recruitment consultants, offering sustained value addition to candidates as well as clients. Our excellent customer service and flexible payment option make us the most preferred talent partner.',
    icon: NewspaperIcon,
  },
];
const faqs = [
  {
    id: 1,
    question: 'Recruitment at all levels',
  },
  {
    id: 2,
    question: 'Head-hunting',
  },
  {
    id: 3,
    question: 'Job Advertising',
  },
  {
    id: 4,
    question: 'Candidate Orientation',
  },
  {
    id: 5,
    question: 'Salary Survey',
  },
  {
    id: 5,
    question: 'Project Based hiring',
  },
];

export default function AboutUS() {
  return (
    <div className="min-h-screen bg-white">
      <LandingAppBar />
      <div className="pt-10 bg-gradient-to-r from-blue-900 to-blue-800 sm:pt-16 lg:pt-8 lg:pb-14 lg:overflow-hidden">
        <div className="mx-auto max-w-7xl lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-8">
            <div className="max-w-md px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center">
              <div className="lg:py-24">
                <h1 className="mt-4 text-4xl tracking-tight font-extrabold text-white sm:mt-5 sm:text-6xl lg:mt-6 xl:text-6xl">
                  <span className="block">About Us</span>
                </h1>
              </div>
            </div>
            <div className="lg:mt-12 -mb-16 sm:-mb-48 lg:m-0 lg:relative pb-28 mt-4">
              <div className="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:max-w-none lg:px-0 min-h-full">
                <h1 className="w-full lg:absolute lg:inset-y-0 lg:left-0 lg:h-full lg:w-auto lg:max-w-none text-white text-3xl tracking-tight text-white lg:pt-16 pt-0 qheading">
                  “The only way to do great work is to love what you do. If you
                  haven't found it yet, keep looking. Don't settle“ - <br />
                  Steve Jobs.
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <main>
        <div className="bg-blue-gray-50">
          {/* Cards */}
          <section
            className="-mt-10 max-w-md mx-auto relative z-10 px-4 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8"
            aria-labelledby="contact-heading"
          >
            <h2 className="sr-only" id="contact-heading">
              Contact us
            </h2>
            <div className="grid grid-cols-1 gap-y-20 lg:grid-cols-3 lg:gap-y-0 lg:gap-x-8">
              {supportLinks.map((link) => (
                <div
                  key={link.name}
                  className="flex flex-col bg-white rounded-2xl shadow-xl"
                >
                  <div className="flex-1 relative pt-16 px-6 pb-8 md:px-8">
                    <div className="absolute top-0 p-5 inline-block bg-blue-600 rounded-xl shadow-lg transform -translate-y-1/2">
                      <link.icon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </div>
                    <h3 className="text-xl font-bold text-blue-gray-900">
                      {link.name}
                    </h3>
                    <p className="mt-4 text-base text-gray-800">
                      {link.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        <div className="pb-16 lg:pb-0 lg:z-10 lg:relative mt-8 mb-24 pt-8 px-4">
          <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-3 lg:gap-8">
            <div className="mt-12 lg:m-0 lg:col-span-3">
              <div className="mx-auto">
                <blockquote>
                  <div>
                    <p className="mt-0 text-base font-medium text-gray-800 text-left">
                      V REKRUT is a UAE based recruitment agency specializing in
                      recruitment at all levels. We started off our operations
                      after 12+ years of experience in the UAE’s recruitment
                      industry.
                    </p>
                    <p className="mt-4 text-base font-medium text-gray-800 text-left">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;V
                      REKRUT has been established by recruitment specialists
                      with years of experience in the MENA (Middle east & north
                      Africa) region. We have worked with enterprises from local
                      as well as international markets, our industry knowledge
                      has personified by working with multinational companies
                      (MNC’s) & global level companies indulged into a variety
                      of business activities such as healthcare, banking &
                      finance, insurance, oil & gas, retail, technology, as well
                      as the public sector (government institutions).
                    </p>
                    <p className="mt-4 text-base font-medium text-gray-800 text-left">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;We
                      head hunt talent from c-level to executive level
                      positions, and we aspire to be the talent partner of
                      organizations that make a difference in the market in
                      terms of leadership, innovation, and contribute to the
                      economies of scale. At V REKRUT, we believe in growth by
                      purpose not by choice. Our purpose comes from progressing
                      ahead with our work efficiently. This helps us achieve our
                      primary goal: client satisfaction.
                    </p>
                  </div>
                </blockquote>
              </div>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="max-w-7xl mx-auto md:mb-14 mt-14">
            <img src="/imgs/Vrekrut-image-about us.jpg" alt="" />
          </div>
        </div>

        {/*<div className="relative bg-gray-900">*/}
        {/*  <div className="relative h-56 bg-blue-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">*/}
        {/*    <img*/}
        {/*      className="w-full h-full object-cover"*/}
        {/*      src="https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&sat=-100"*/}
        {/*      alt=""*/}
        {/*    />*/}
        {/*    <div*/}
        {/*      aria-hidden="true"*/}
        {/*      className="absolute inset-0 bg-gradient-to-r from-teal-500 to-cyan-600 mix-blend-multiply"*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  <div className="relative mx-auto max-w-md px-4 py-12 sm:max-w-7xl sm:px-6 sm:py-20 md:py-28 lg:px-8 lg:py-32">*/}
        {/*    <div className="md:ml-auto md:w-1/2 md:pl-10">*/}
        {/*      <h2 className="text-base font-semibold uppercase tracking-wider text-gray-300">*/}
        {/*        We ensure that we provide our consultation until the final step*/}
        {/*        i.e., the first day of the hired candidate at your company.*/}
        {/*      </h2>*/}
        {/*      <p className="mt-3 text-lg text-gray-300">*/}
        {/*        That is how we stay committed to our clients, we believe in*/}
        {/*        establishing a long-term relationship in business, and the only*/}
        {/*        method we can achieve that is by being true to our work and our*/}
        {/*        clients.*/}
        {/*      </p>*/}
        {/*      <p className="mt-2 text-white text-3xl font-extrabold tracking-tight sm:text-4xl">*/}
        {/*        V REKRUT provides everything that you may need*/}
        {/*      </p>*/}

        {/*      <div className="mt-8">*/}
        {/*        <div className="inline-flex rounded-md shadow">*/}
        {/*          <Link*/}
        {/*            to="/contact-us"*/}
        {/*            className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-white hover:bg-gray-50"*/}
        {/*          >*/}
        {/*            Contact Us*/}
        {/*            <ExternalLinkIcon*/}
        {/*              className="-mr-1 ml-3 h-5 w-5 text-gray-400"*/}
        {/*              aria-hidden="true"*/}
        {/*            />*/}
        {/*          </Link>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </main>

      <Footer />
    </div>
  );
}
